import {
  HttpEvent,
  HttpHandlerFn,
  HttpRequest
} from '@angular/common/http';
import {ErrorHandler, inject} from "@angular/core";
import {AuthService} from "./Auth.service";
import {catchError, finalize, map, Observable, shareReplay, switchMap, throwError} from "rxjs";
import {ConfigService} from "../config.service";
import {Response} from "../../modules/response.module";
import {HttpService, isServerUnreachable} from "../../../services/http.service";



export function authInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn) {
  // Inject the current `AuthService` and use it to get an authentication token:
  const authService = inject(AuthService);
  // Clone the request to add the authentication header.

  const token = authService.getToken;
  if (!token) return next(req);

  const newReq = req.clone({
    headers: req.headers.append('authorization', "Bearer " + token),
  });
/*
  console.log("authInterceptor new req :  " + JSON.stringify(newReq))
*/
  return next(newReq);
}


export class reLoginInterceptor2 implements ErrorHandler{
  handleError(error: any): void {



  }

}
// The refresh currently in flight, shared by every request that hits a 401 meanwhile.
// Refresh tokens are typically single-use, so a second concurrent refresh would present
// an already-rotated token, be rejected, and log the user out.
let refreshInFlight$: Observable<string | null> | null = null;

// Emits the new access token, or null when the server rejected the refresh (the user is
// logged out by then). Errors when the refresh call itself failed.
function refreshAccessToken(authService: AuthService, httpClient: HttpService, refreshUrl: string): Observable<string | null> {
  if (!refreshInFlight$) {
    refreshInFlight$ = httpClient.post<Response>(refreshUrl, { refreshToken: authService.getRefreshToken }).pipe(
        map((response) => {
          if (response.isSuccess) {
            authService.refreshOldToken(response.data.token, response.data.refreshToken);
            return response.data.token as string;
          }
          // If refresh fails, log out the user
          authService.logout();
          return null;
        }),
        catchError((refreshError) => {
          // If the refresh call itself failed because the server is unreachable,
          // HttpService has already redirected to /login with an explanatory
          // message — don't clobber that by wiping tokens and re-navigating to a
          // bare /login here. Only treat this as a real logout when the server was
          // reachable and rejected the refresh.
          if (!isServerUnreachable(refreshError)) {
            authService.logout();
          }
          return throwError(() => refreshError);
        }),
        finalize(() => refreshInFlight$ = null),
        shareReplay({ bufferSize: 1, refCount: false })
    );
  }
  return refreshInFlight$;
}

export function reLoginInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
  const authService = inject(AuthService);
  const httpClient = inject(HttpService);
  const loginUrl = inject(ConfigService).RefreshTokenUrl;

  // Skip interceptor for the token refresh request itself
  if (req.url === loginUrl) {
    return next(req);
  }

  return next(req).pipe(
      catchError((error) => {
        // Only a 401 with a refresh token to try is recoverable; anything else is re-thrown
        if (error.status !== 401 || !authService.getRefreshToken) {
          return throwError(() => error);
        }

        const retryWith = (token: string) =>
            next(req.clone({ setHeaders: { Authorization: `Bearer ${token}` } }));

        // Another request already refreshed the token after this one was sent: retry with
        // the current token instead of refreshing again.
        const sentWith = req.headers.get('Authorization');
        if (sentWith && sentWith !== `Bearer ${authService.getToken}`) {
          return retryWith(authService.getToken);
        }

        return refreshAccessToken(authService, httpClient, loginUrl).pipe(
            switchMap((token) => token ? retryWith(token) : throwError(() => error))
        );
      })
  );
}

